import { render } from "./Application.vue?vue&type=template&id=382b193e"
import script from "./Application.vue?vue&type=script&lang=js"
export * from "./Application.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/Application.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "382b193e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('382b193e', __exports__)) {
    api.reload('382b193e', __exports__)
  }
  
  module.hot.accept("./Application.vue?vue&type=template&id=382b193e", () => {
    api.rerender('382b193e', render)
  })

}


export default __exports__